<template>
  <VModal
      title="نظرسنجی"
      :show="show">

    <table class="w-full text-right mt-4">
      <thead>
      <tr class="text-sm text-muted">
        <th>سوال</th>
        <th>امتیاز</th>
      </tr>
      </thead>

      <tbody class="divide-y divide-gray-400">
      <tr v-for="detail in surveyDetails"
          :key="detail.id">
        <td class="py-1">{{ detail.survey_question.question }}</td>
        <td>{{ detail.score }}</td>
      </tr>
      </tbody>
    </table>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";

export default {
  name: "ModalSurveyResult",
  components: {VModal},
  props: {
    show: Boolean,
    surveyDetails: Array
  },
}
</script>

<style scoped>

</style>